// extracted by mini-css-extract-plugin
module.exports = {"container":"ECommPage_container__3VDN_","textRow":"ECommPage_textRow__5LNTc"};